
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-game",
      function () {
        return require("private-next-pages/new-game.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-game"])
      });
    }
  